import React, { useEffect, useState } from "react";
import { Skeleton, Row, Col, Tabs, Descriptions, Button, Tag } from "antd";
import { HomeOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import moment from "moment";
import apis from "../../../services/Apis";
import { SecureGet } from "../../../services/axiosCall";
import "./questiondetails.css";


const QuestionDetails = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    SecureGet({ url: `${apis.FETCH_SINGLE_QUESTION}/${id}` })
      .then((response) => {
        setDetails(response.data.data[0]);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        setLoading(false);
      });
  }, [id]);

  const tabChange = (key) => {
    // Placeholder if needed
  };

  const items = [
    {
      key: "1",
      label: (
        <span>
          <HomeOutlined style={{marginRight:5}}/>
          Basic Info
        </span>
      ),
      children: details && <Tab1 id={id} details={details} />,
    },
    {
      key: "2",
      label: (
        <span>
          <QuestionCircleOutlined style={{marginRight:5}}/>
          Question
        </span>
      ),
      children: details && <Tab2 details={details} />,
    },
  ];

  return (
    <Skeleton loading={loading} active avatar>
      <Tabs defaultActiveKey="1" onChange={tabChange} items={items} />
    </Skeleton>
  );
};

export default QuestionDetails;

function Tab1({ id, details }) {
  return (
    <Descriptions
      bordered
      size="small"
      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
    >
      <Descriptions.Item label="Question Id">{id}</Descriptions.Item>
      <Descriptions.Item label="Subject">
        {details.subject.topic}
      </Descriptions.Item>
      <Descriptions.Item label="Difficulty">
        {details.difficulty}
      </Descriptions.Item>
      <Descriptions.Item label="No of Right Answers">
        {details.anscount}
      </Descriptions.Item>
      <Descriptions.Item label="Level">{details.level}</Descriptions.Item>
      <Descriptions.Item label="Weightage">
        {details.weightage}
      </Descriptions.Item>
      <Descriptions.Item label="School">
        {details.school || "Not Available"}
      </Descriptions.Item>
      <Descriptions.Item label="Year">
        {details.year || "Not Available"}
      </Descriptions.Item>
      <Descriptions.Item label="Topic">
        {details.topic || "Not Available"}
      </Descriptions.Item>
      <Descriptions.Item label="Component">
        {details.component || "Not Available"}
      </Descriptions.Item>
      <Descriptions.Item label="Exam">{details.exam}</Descriptions.Item>
      <Descriptions.Item label="Created on">
        {moment(details.createdAt).format("DD/MM/YYYY , hh:mm:ss")}
      </Descriptions.Item>
    </Descriptions>
  );
}

function Tab2(props) {
  const optn = ["A", "B", "C", "D", "E"];
  const Optiondata = props.details;

  const image =
    Optiondata.quesimg && Optiondata.quesimg.split("www.leagueonline.sg:5000");
  const path = apis.BASE_LOCAL_URL;
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
  const videoExtensions = ["mp4", "avi", "mov", "mkv"];
  // Extract the file extension from the URL
  const extension =
    Optiondata.quesimg == undefined || Optiondata.quesimg == null
      ? ""
      : image && image[0] === "https://"
      ? image[1].split(".").pop().toLowerCase()
      : Optiondata.quesimg.split(".").pop().toLowerCase();
  return (
    <div className="mainQuestionDetailsContaine">
      <div style={{ fontWeight: "700", paddingBottom: "20px" }}>
        <div dangerouslySetInnerHTML={{ __html: Optiondata.body }}></div>
      </div>
      {Optiondata.quesimg ? (
        <div className="questionDetailsImageContainer">
          {imageExtensions.includes(extension) ? (
            image && image[0] === "https://" ? (
              <img src={path + image[1]} className="image-tag" />
            ) : (
              <img
                src={path + "/" + Optiondata.quesimg}
                className="image-tag"
              />
            )
          ) : videoExtensions.includes(extension) ? (
            image && image[0] === "https://" ? (
              <video className="image-tag" controls>
                <source src={path + image[1]} type="video/mp4" />
              </video>
            ) : (
              <video className="image-tag" controls>
                <source
                  src={path + "/" + Optiondata.quesimg}
                  type="video/mp4"
                />
              </video>
            )
          ) : null}
        </div>
      ) : null}
      <div>
        {Optiondata.isMcq ? (
          Optiondata.options ? (
            Optiondata.options.map((d, i) => {
              return (
                <div key={i}>
                  <Row
                    type="flex"
                    justify="center"
                    className="QuestionDetailsOptions"
                  >
                    <Col span={2}>
                      {d.isAnswer ? (
                        <Button className="green" shape="circle">
                          {optn[i]}
                        </Button>
                      ) : (
                        <Button type="primary" shape="circle">
                          {optn[i]}
                        </Button>
                      )}
                    </Col>
                    {d.optimg ? (
                      <Col span={6} style={{ padding: "5px" }}>
                        <img
                          crossorigin="anonymous"
                          alt="unable to load"
                          width="200px"
                          height="200px"
                          className="questionDetailsImage"
                          src={d.optimg}
                        />
                      </Col>
                    ) : null}
                    {d.optimg ? (
                      <Col span={14}>{d.optbody}</Col>
                    ) : (
                      <Col span={20}>{d.optbody}</Col>
                    )}
                  </Row>
                </div>
              );
            })
          ) : null
        ) : (
          <>
            Ans: &nbsp;
            {!Optiondata.customAnswer || Optiondata.customAnswer.length === 0
              ? null
              : Optiondata.customAnswer.map((item) => (
                  <Tag color="green" style={{ fontSize: "1rem" }}>
                    {item}

                    <br />
                  </Tag>
                ))}
          </>
        )}
      </div>
    </div>
  );
}
